import { IContentCards } from '@models/IContentCards';
import VariantTypeEnum from '@models/enums/VariantTypeEnum';
import ArticleCard from '@molecules/ArticleCard/ArticleCard';
import CardListing from '@molecules/CardListing/CardListing';
import ContentCard from '@molecules/ContentCard/ContentCard';
import useMediaQuery from '@utility/hooks/useMediaQuery';

const ContentCards = ({
  backgroundColour,
  cardStyle,
  cardType,
  cards,
  cta,
  displayAs,
  hideCardBackground,
  hideCardCtas,
  hideCardText,
  hideImages,
  itemsPerRow,
  portraitImages,
  site,
  title,
  useSerifTitleFont,
}: IContentCards) => {
  const isMobile = useMediaQuery(1024);
  const isTertiary = cardStyle === VariantTypeEnum.Tertiary;

  if (!cards) return;

  return (
    <CardListing
      cta={cta}
      displayAs={displayAs}
      itemsPerRow={itemsPerRow}
      site={site}
      title={title}
      cards={cards.map((card) =>
        cardType === 'article' || isTertiary ? (
          <ArticleCard
            {...card}
            key={card.title}
            image={card.image!}
            portraitImages={portraitImages}
            url={card.ctas?.[0]?.url ?? ''}
            target={card.ctas?.[0]?.target}
            titleVariant={
              !isTertiary || useSerifTitleFont
                ? isMobile
                  ? 'heading-28'
                  : 'heading-32'
                : 'heading-24-light'
            }
            truncateTitle={!isTertiary}
            background={isTertiary ? 'white' : 'grey'}
          />
        ) : (
          <ContentCard
            key={card.title}
            {...card}
            site={site}
            variant={cardStyle}
            hideCta={hideCardCtas}
            hideImage={hideImages}
            hideText={hideCardText}
            backgroundColour={backgroundColour}
            hideBackground={
              (cardStyle === VariantTypeEnum.Secondary && !hideImages) ||
              hideCardBackground
            }
            isRichTextBody
            truncateText
          />
        )
      )}
    />
  );
};

export default ContentCards;
